import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { DepartmentCardComponent } from '../department-card/department-card.component';
import { DepartmentListComponent } from './department-list.component';

@NgModule({
    declarations: [DepartmentListComponent, DepartmentCardComponent],
    imports: [CommonModule, MatProgressSpinnerModule, TranslateModule, MatIconModule, MatButtonModule, MatMenuModule],
    exports: [DepartmentListComponent],
})
export class DepartmentListModule {}
